export const founders = [
  {
    id: 1,
    founder: "Mr Dozie Dike (Head of schools)",
    phone: "+2349030838298",
    email: "sultanhighschool@gmail.com",
  },
  {
    id: 2,
    founder: "Mrs Dora Peters (Head of schools)",
    phone: "+2349030838298",
    email: "dorapeters@gmail.com",
  },
];
export const schools = [
  {
    id: 1,
    password: "crigs902378",
    username: "Finesse",
    name: "St. Crigs High School",
    status: "Pending",
    regID: "NAPPS-988737",
    zone: "North East (NE)",
    bg: "#F9FAFB",
    colo: "#344054",
    alphabet: "S",
    bg2: "#AA9C75",
    category: ["pending", "NE"],
    founder_id: 1,
    zone_id: 1,
    state_id: "",

    about:
      "Founded in 1975 by Sir Leonard St. Crigs, St. Crigs High School has long been a beacon of academic excellence and integrity. Nestled in the heart of the city, the school offers a broad curriculum that balances rigorous academic standards with extensive extracurricular programs. Over the decades, St. Crigs has cultivated a tradition of excellence, producing graduates who excel in various fields such as medicine, law, and engineering. The school's state-of-the-art facilities, including advanced science laboratories, a comprehensive library, and modern sports amenities, provide students with the resources they need to thrive. The dedicated faculty at St. Crigs High School are committed to fostering a supportive and challenging learning environment that encourages students to reach their full potential..",
    vision:
      "Our vision is to raise a generation of students with the right tools, skills, moral and mental abilities to excel in life and contribute positively to the development of mankind. In fulfilling our mission, we seek to achieve the following:",
    mission:
      "Impart high quality education to students and develop inquiring minds and a desire for knowledge. Develop strong self-esteem and high personal expectation, and acquire a set of spiritual and moral values. Equip students with the tools to excel in life and skills to manage changes. Provide conducive environment for learning, and expose students to the rich and diverse culture of the environment and Nigeria in general. Impart leadership skills.",
    founder: "Mr Dozie Dike (Head of schools)",
    website: "St.crigshighschool.com.ng",
    phone: "+2348059838298",
    state: "Lagos",
    country: "Nigeria",
    email: "St.crigshighschool@gmail.com",
    address1: "1, British Spring Estate Road, Nkwelle Awka, Anambra State.",
    address2:
      "Springfield Academy, 30 New Nkisi Road, GRA Onitsha Anambra state.",
    federal: "20%",
    zonal: "10%",
    lga: "20%",
    statePercent: "30%",
    ward: "10%",
    total: "100%",
    accName: "Peter Olugbenga",
  },
  {
    password: "sultan5683",
    username: "Glory",
    id: 2,
    name: "Sultan High School",
    status: "Active",
    bg: "#ECFDF3",
    colo: "#027A48",
    regID: "NAPPS-988737",
    zone: "North East (NE)",
    alphabet: "D",
    bg2: "#2A86D3",
    country: "Nigeria",
    category: ["active", "NE"],
    zone_id: 1,
    state_id: 1,
    about:
      "Established in 1982 by renowned philanthropist Amina Sultan, Sultan High School is celebrated for its strong emphasis on cultural diversity and inclusivity. Situated in a multicultural neighborhood, the school attracts students from various backgrounds, fostering a rich tapestry of perspectives and experiences. Sultan High School's curriculum is designed to promote global awareness and intercultural understanding, with special programs in world languages, international relations, and cultural studies. The school also offers robust arts and sports programs, ensuring a well-rounded education. With its committed staff and vibrant student body, Sultan High School creates an environment where every student feels valued and empowered to succeed academically and socially.",
    vision:
      "Sultan High School envisions a vibrant, inclusive learning environment where cultural diversity is celebrated and every student is empowered to achieve global competence and personal success.",
    mission:
      "Sultan High School is committed to offering a diverse and inclusive educational experience that promotes intercultural understanding, academic excellence, and the holistic development of every student.",
    website: "sultanhighschool.com.ng",
    founder: "Mr Dozie Dike (Head of schools)",
    phone: "+2349030838298",
    email: "sultanhighschool@gmail.com",
    state: "Kaduna",
    founder_id: 2,
    address1: "1, British Spring Estate Road, Nkwelle Awka, Anambra State.",
    address2:
      "Springfield Academy, 30 New Nkisi Road, GRA Onitsha Anambra state.",
    federal: "20%",
    zonal: "10%",
    lga: "20%",
    statePercent: "30%",
    ward: "10%",
    total: "100%",
    accName: "Peter Olugbenga",
  },
  {
    id: 3,
    password: "brit49684",
    username: "Bodunde",
    name: "BritishSpring College",
    status: "Active",
    regID: "NAPPS-988737",
    zone: "North Central (NC)",
    bg: "#ECFDF3",
    colo: "#027A48",
    alphabet: "B",
    bg2: "#EF9995",
    category: ["active", "NC"],
    about:
      "BritishSpring College, founded in 1990 by esteemed British educator Dr. William Spring, stands out for its seamless integration of British and local curricula. Located in a picturesque suburban area, the college is known for its high academic standards and comprehensive educational approach. BritishSpring College offers a wide range of subjects, including advanced science courses, humanities, and technical education, preparing students for both local and international higher education opportunities. The school boasts impressive facilities, such as fully equipped science labs, art studios, and a modern sports complex. Dr. Spring's vision of creating a dynamic learning environment that fosters critical thinking and creativity is evident in every aspect of the school.",
    vision:
      "BritishSpring College strives to blend the best of British and local educational practices, fostering critical thinkers and innovative leaders prepared for global challenges.",
    mission:
      "The mission of BritishSpring College is to deliver a comprehensive education that merges British and local standards, encouraging intellectual curiosity, creativity, and leadership in our students.",
    founder: "Mr Dozie Dike (Head of schools)",
    website: "britishspringcollege.com.ng",
    phone: "+2348047478298",
    state: "Abuja",
    country: "Nigeria",
    email: "britishspringcollege@gmail.com",
    address1: "1, British Spring Estate Road, Nkwelle Awka, Anambra State.",
    address2:
      "Springfield Academy, 30 New Nkisi Road, GRA Onitsha Anambra state.",
    federal: "20%",
    zonal: "10%",
    lga: "20%",
    statePercent: "30%",
    ward: "10%",
    total: "100%",
    accName: "Peter Olugbenga",
  },
  {
    id: 4,
    password: "dowen4967",
    username: "Ladynofiu",
    name: "Dowen College",
    status: "Inactive",
    regID: "NAPPS-988737",
    zone: "North Central (NC)",
    bg: "#FEF3F2",
    colo: "#F04438",
    alphabet: "S",
    bg2: "#2A7918",
    category: ["inactive", "NC"],
    about:
      "Launched in 1997 by visionary entrepreneur Olumide Dowen, Dowen College is synonymous with innovation and excellence. Situated in a bustling urban center, the college offers a cutting-edge curriculum that blends traditional academics with modern technology and entrepreneurship education. Dowen College is equipped with state-of-the-art facilities, including smart classrooms, a digital library, and advanced laboratories, providing students with the tools they need to excel in the 21st century. The school emphasizes practical learning experiences and industry partnerships, preparing students for real-world challenges. Under Olumide Dowen's leadership, the college has become a leader in educational innovation, producing graduates who are not only academically proficient but also entrepreneurial and tech-savvy..",
    vision:
      "Dowen College aims to be a center of excellence in education, where students are equipped with the knowledge, skills, and entrepreneurial spirit to thrive in a rapidly evolving world.",
    mission:
      "Dowen College's mission is to create an innovative learning environment that blends traditional academics with modern technology and entrepreneurial education, equipping students for future success.",
    founder: "Mr Dozie Dike (Head of schools)",
    website: "dowencollege.com.ng",
    phone: "+2348047925398",
    state: "Lagos",
    country: "Nigeria",
    email: "dowencollege@gmail.com",
    address1: "1, British Spring Estate Road, Nkwelle Awka, Anambra State.",
    address2:
      "Springfield Academy, 30 New Nkisi Road, GRA Onitsha Anambra state.",
    federal: "20%",
    zonal: "10%",
    lga: "20%",
    statePercent: "30%",
    ward: "10%",
    total: "100%",
    accName: "Peter Olugbenga",
  },
  {
    id: 5,
    password: "cherr8953",
    name: "CherryField College",
    username: "Sharpy",
    status: "Inactive",
    regID: "NAPPS-988737",
    zone: "South West (SW)",
    bg: "#FEF3F2",
    colo: "#F04438",
    alphabet: "S",
    bg2: "#2A7918",
    category: ["inactive", "SW"],
    about:
      "CherryField College, founded by the dedicated educator Jane Cherry in 2000, prides itself on creating a nurturing and supportive learning environment. Located in a serene, leafy suburb, the college is known for its focus on student well-being and personal development. CherryField College offers a broad curriculum that includes strong academic programs, arts, and community service initiatives, ensuring a holistic education. The school's beautiful campus features modern classrooms, art studios, and recreational facilities that encourage both academic and personal growth. Jane Cherry's commitment to fostering a caring community is reflected in the school's approach, which emphasizes respect, empathy, and collaboration among students and staff.",
    vision:
      "CherryField College is dedicated to nurturing well-rounded individuals through a balanced education that promotes academic excellence, personal growth, and community engagement.",
    mission:
      "CherryField College aims to provide a nurturing and supportive educational environment where students are encouraged to achieve academic excellence, develop strong character, and engage in their communities.",
    founder: "Mr Dozie Dike (Head of schools)",
    website: "cherryfieldcollege.com.ng",
    phone: "+2348039085398",
    state: "Abuja",
    email: "cherryfieldcollege@gmail.com",
    address1: "1, British Spring Estate Road, Nkwelle Awka, Anambra State.",
    address2:
      "Springfield Academy, 30 New Nkisi Road, GRA Onitsha Anambra state.",
    federal: "20%",
    zonal: "10%",
    lga: "20%",
    statePercent: "30%",
    ward: "10%",
    total: "100%",
    accName: "David Bodunde",
  },
  {
    id: 6,
    password: "wisv90356",
    username: "Gilberth",
    name: "WisVille Schools Enugu",
    status: "Active",
    regID: "NAPPS-988737",
    zone: "South West (SW)",
    bg: "#ECFDF3",
    colo: "#027A48",
    alphabet: "S",
    bg2: "#2A7918",
    category: ["active", "SW"],
    about:
      "Established in 2003 by Dr. Chris Wisville, WisVille Schools Enugu focuses on providing a holistic education that balances academics, character development, and extracurricular activities. Located in Enugu, the school is renowned for its innovative teaching methods and commitment to educational excellence. WisVille Schools offer a diverse curriculum that includes STEM programs, arts, and humanities, catering to a wide range of interests and aptitudes. The school's facilities are top-notch, featuring modern science labs, a comprehensive library, and extensive sports facilities. Dr. Wisville's vision of nurturing well-rounded individuals is evident in the school's emphasis on leadership, community service, and personal growth.",
    vision:
      "WisVille Schools Enugu aspires to develop holistic learners who excel academically, demonstrate strong character, and are prepared to make meaningful contributions to their communities.",
    mission:
      "WisVille Schools Enugu is dedicated to offering a holistic education that balances academic achievement, character development, and extracurricular activities, fostering well-rounded and resilient students.",
    founder: "Mr Dozie Dike (Head of schools)",
    website: "wisvilleschoolsenugu.com.ng",
    phone: "+2348039085398",
    state: "Enugu",
    country: "Nigeria",
    email: "wisvilleschoolsenugu@gmail.com",
    address1: "1, British Spring Estate Road, Nkwelle Awka, Anambra State.",
    address2:
      "Springfield Academy, 30 New Nkisi Road, GRA Onitsha Anambra state.",
    federal: "20%",
    zonal: "10%",
    lga: "20%",
    statePercent: "30%",
    ward: "10%",
    total: "100%",
    accName: "David Bodunde",
  },
  {
    id: 7,
    password: "hilt687433",
    username: "Melody",
    name: "Hilton Top HighSchool",
    status: "Active",
    regID: "NAPPS-988737",
    zone: "North West (NW)",
    bg: "#ECFDF3",
    colo: "#027A48",
    alphabet: "S",
    bg2: "#2A7918",
    category: ["active", "WN"],
    about:
      "Founded by Margaret Hilton in 2005, Hilton Top HighSchool is renowned for its rigorous academic programs and commitment to student success. Situated in a vibrant community, the school offers a challenging curriculum that prepares students for higher education and future careers. Hilton Top HighSchool boasts impressive facilities, including advanced science and computer labs, a well-stocked library, and extensive sports amenities. The school's dedicated faculty and staff work tirelessly to create a supportive and motivating learning environment. Margaret Hilton's vision of excellence is reflected in the school's focus on high academic standards, personal integrity, and community involvement, making it a top choice for families seeking quality education.",
    vision:
      "Hilton Top HighSchool envisions an educational environment where high academic standards, personal integrity, and community involvement create the foundation for student success.",
    mission:
      "Hilton Top HighSchool's mission is to provide a challenging and supportive academic environment that encourages personal integrity, high achievement, and active participation in the community.",
    founder: "Mr Dozie Dike (Head of schools)",
    website: "hiltontophighschool.com.ng",
    phone: "+2348039085298",
    state: "Enugu",
    email: "hiltontophighschool@gmail.com",
    address1: "1, British Spring Estate Road, Nkwelle Awka, Anambra State.",
    address2:
      "Springfield Academy, 30 New Nkisi Road, GRA Onitsha Anambra state.",
    federal: "20%",
    zonal: "10%",
    lga: "20%",
    statePercent: "30%",
    ward: "10%",
    total: "100%",
    accName: "David Bodunde",
  },
  {
    id: 9,
    password: "mont389222",
    username: "Marisel",
    name: "Montessori International School",
    status: "Pending",
    regID: "NAPPS-988737",
    zone: "South South (SS)",
    bg: "#F9FAFB",
    colo: "#344054",
    alphabet: "S",
    bg2: "#2A7918",
    category: ["pending", "SS"],
    about:
      "Founded by Maria T. Montessori in 2015, Montessori International School offers a unique, child-centered approach to education based on the Montessori philosophy. Located in a peaceful residential area, the school is designed to foster independence, creativity, and a love for learning. Montessori International School features specially prepared classrooms with hands-on learning materials that encourage exploration and discovery. The school's curriculum covers a wide range of subjects, including language arts, mathematics, science, and cultural studies, all taught through interactive and engaging methods. Maria T. Montessori's vision of an educational environment that respects and nurtures each child's individual potential is at the heart of the school's philosophy and practices.",
    vision:
      "Montessori International School seeks to nurture independent, creative learners who are empowered to explore their potential and contribute thoughtfully to the world around them.",
    mission:
      "The mission of Montessori International School is to offer a child-centered education based on Montessori principles, fostering independence, creativity, and a lifelong love of learning in a respectful and supportive environment",
    founder: "Mr Dozie Dike (Head of schools)",
    website: "montessoriinternationalschool.com.ng",
    phone: "+2348034485298",
    state: "Lagos",
    country: "Nigeria",
    email: "montessoriinternationalschool@gmail.com",
    address1: "1, British Spring Estate Road, Nkwelle Awka, Anambra State.",
    address2:
      "Springfield Academy, 30 New Nkisi Road, GRA Onitsha Anambra state.",
    federal: "20%",
    zonal: "10%",
    lga: "20%",
    statePercent: "30%",
    ward: "10%",
    total: "100%",
    accName: "Uwanna Glory",
  },
  {
    id: 8,
    password: "norwe4855",
    username: "George",
    name: "Norwegian College",
    status: "Pending",
    regID: "NAPPS-988737",
    zone: "South South (SS)",
    bg: "#F9FAFB",
    colo: "#344054",
    alphabet: "S",
    bg2: "#2A7918",
    category: ["pending", "SS"],
    about:
      "Opened in 2010 by Dr. Erik Nilsen, Norwegian College brings Scandinavian educational principles to the local context, offering a unique approach to learning. Located in a tranquil setting, the college emphasizes experiential learning, critical thinking, and environmental awareness. Norwegian College's curriculum includes strong academic programs alongside innovative courses in sustainability, outdoor education, and global citizenship. The school's campus features eco-friendly buildings, outdoor classrooms, and state-of-the-art laboratories, providing an ideal environment for holistic education. Dr. Nilsen's dedication to fostering a love for learning and a sense of global responsibility is evident in every aspect of Norwegian College's approach.",
    vision:
      "Norwegian College aims to inspire a love for learning and a commitment to global citizenship through an innovative, experiential curriculum that emphasizes sustainability and critical thinking.",
    mission:
      "Norwegian College is committed to delivering an education that emphasizes experiential learning, environmental stewardship, and critical thinking, preparing students to become informed and responsible global citizens.",
    founder: "Mr Dozie Dike (Head of schools)",
    website: "norwagiancollege.com.ng",
    phone: "+2348034561298",
    state: "Enugu",
    country: "Nigeria",
    email: "norwagiancollege@gmail.com",
    address1: "1, British Spring Estate Road, Nkwelle Awka, Anambra State.",
    address2:
      "Springfield Academy, 30 New Nkisi Road, GRA Onitsha Anambra state.",
    federal: "20%",
    zonal: "10%",
    lga: "20%",
    statePercent: "30%",
    ward: "10%",
    total: "100%",
    accName: "Peter Olugbenga",
  },
];
